import React from 'react';
import { motion } from 'framer-motion';
import BrewStation from '../BrewStation';

interface BrewingGridProps {
  constraintsRef: React.RefObject<HTMLDivElement>;
  gridDimensions: any;
  brewStations: any[];
  isLargeScreen: boolean;
  inventoryPanelWidth: number;
  customerQueueWidth: number;
  inventoryPanelOpen: boolean;
  customerQueueOpen: boolean;
}

const BrewingGrid: React.FC<BrewingGridProps> = ({
  constraintsRef,
  gridDimensions,
  brewStations,
  isLargeScreen,
  inventoryPanelWidth,
  customerQueueWidth,
  inventoryPanelOpen,
  customerQueueOpen,
}) => {
  const panelTransition = { type: "tween", ease: "easeInOut", duration: 0.3 };

  return (
    <motion.div
      ref={constraintsRef}
      className="flex-1 relative overflow-auto mobile-game-area"
      style={{
        minHeight: `${gridDimensions.totalHeight}px`,
        minWidth: `${gridDimensions.totalWidth}px`,
        touchAction: 'pan-x pan-y',
        backgroundImage: `
          linear-gradient(to right, #D1D5DB 1px, transparent 1px),
          linear-gradient(to bottom, #D1D5DB 1px, transparent 1px)
        `,
        backgroundSize: `${gridDimensions.tileSize}px ${gridDimensions.tileSize}px`,
        backgroundPosition: `${gridDimensions.padding}px ${gridDimensions.padding}px`,
      }}
      animate={{
        marginLeft: isLargeScreen && inventoryPanelOpen ? `${inventoryPanelWidth}px` : '0px',
        marginRight: isLargeScreen && customerQueueOpen ? `${customerQueueWidth}px` : '0px',
      }}
      transition={panelTransition}
    >
      {brewStations.map((station, stationIndex) => (
        <BrewStation
          key={stationIndex}
          stationIndex={stationIndex}
          constraintsRef={constraintsRef}
          gridDimensions={gridDimensions}
          isLargeScreen={isLargeScreen}
        />
      ))}
    </motion.div>
  );
};

export default BrewingGrid;
